import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { prettifyCardStars } from '@utils/index';
import InfoBlock from '@components/common/info_block';

const DeleteCardModal = () => {
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Typography variant="h4">Remove card</Typography>
            <Typography className={styles.title} variant="body2">
                {modalData?.card_brand} {prettifyCardStars(modalData?.card_number)} will be unlinked
                from your profile. You can link it again later if needed. Are you sure you want to
                remove this card?
            </Typography>
            <InfoBlock variant="warning">
                Please note: Any pending or scheduled payments set up with this card will be
                canceled. Remember to make other arrangements for future payments you may still owe.
            </InfoBlock>
        </div>
    );
};

export default DeleteCardModal;
